import { useState, useEffect } from 'react'
import { signIn, getCurrentUser, fetchAuthSession } from 'aws-amplify/auth'
import './SimpleAuth.css'

function SimpleAuth({ onAuthSuccess }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [checking, setChecking] = useState(true)

  // Check if user is already logged in
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUser()
        const session = await fetchAuthSession()
        
        // Check if we have valid tokens
        if (session.tokens?.idToken) {
          console.log('User already authenticated:', user)
          onAuthSuccess(user, session)
          return // Don't show login form
        }
        
        console.log('No valid session tokens')
        setChecking(false)
      } catch (err) {
        // No existing session - this is normal for first-time visitors
        console.log('No existing session (this is normal):', err.message || err.name)
        setChecking(false)
      }
    }
    checkAuth()
  }, [onAuthSuccess])

  const handleLogin = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError('')

    try {
      console.log('Attempting login for:', email)
      const result = await signIn({ username: email, password })
      console.log('Sign in result:', result)
      
      if (result.isSignedIn) {
        const user = await getCurrentUser()
        const session = await fetchAuthSession()
        console.log('Login successful, user:', user)
        onAuthSuccess(user, session)
      } else {
        // Sign in might require additional steps (MFA, etc.)
        setError('Sign in incomplete. Please check your email for verification code or try again.')
        setLoading(false)
      }
    } catch (err) {
      console.error('Login error:', err)
      
      // Handle "already signed in" error - use existing session
      if (err.name === 'UserAlreadyAuthenticatedException' || 
          err.message?.includes('already a signed in user') ||
          err.message?.includes('already authenticated')) {
        try {
          const user = await getCurrentUser()
          const session = await fetchAuthSession()
          if (session.tokens?.idToken) {
            console.log('User already authenticated, using existing session')
            onAuthSuccess(user, session)
            return
          }
        } catch (getUserErr) {
          console.error('Error getting existing user:', getUserErr)
        }
      }
      
      // Show user-friendly error message
      const errorMessage = err.message || err.name || 'Failed to sign in. Please check your credentials.'
      setError(errorMessage)
      setLoading(false)
    }
  }

  if (checking) {
    return (
      <div className="simple-auth-container">
        <div className="simple-auth-card">
          <h2>Olivea HR Dashboard</h2>
          <p>Checking authentication...</p>
        </div>
      </div>
    )
  }

  return (
    <div className="simple-auth-container">
      <div className="simple-auth-card">
        <h2>Olive HR Dashboard</h2>
        <form onSubmit={handleLogin}>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            autoComplete="email"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            disabled={loading}
            autoComplete="current-password"
          />
          {error && (
            <div className="auth-error">
              {error}
            </div>
          )}
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  )
}

export default SimpleAuth

